import { IEventClientScheduleDTO } from "../types/events";

export const getDistinctDaysByEvents = (events: {start: Date, end: Date}[]): number[] => {
    const days = [1, 2, 3, 4, 5];
    for(const event of events){
        let dateOfWeekEvent = event.start.getDay();
        if(event.start.getDay() === 0){
            dateOfWeekEvent = 0;
        } else {
            dateOfWeekEvent = event.start.getDay();
        }
 
        if(!days.includes(dateOfWeekEvent)){
            days.push(dateOfWeekEvent);
        }
    }
    return days;
}

export const getDistinctHoursByEvents = (events: {start: Date, end: Date}[]): number[] => {
    const hours = [8, 18];
    for(const event of events){
        if(event.start.getHours() < hours[0]){
            hours[0] = event.start.getHours();
        }
        if(event.end.getHours() > hours[1]){
            hours[1] = event.end.getHours();
        }
    }
    console.log(hours);
    return hours;
}